import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Sidebar from "./components/Layout/Sidebar";
import Dashboard from "./pages/Dashboard";
import Equipment from "./pages/Equipment";
import Projects from "./pages/Projects";
import Customers from "./pages/Customers";
import Crew from "./pages/Crew";
import Invoicing from "./pages/Invoicing";
import Calendar from "./pages/Calendar";
import Settings from "./pages/Settings";
import Login from "./pages/Login";
import EquipmentCalendar from "./pages/EquipmentCalendar";
import CrewCalendar from "./pages/CrewCalendar";
import SignaturePage from "./pages/SignaturePage";
import VerifyEmail from "./pages/VerifyEmail";
import Bookkeeping from "./pages/Bookkeeping";
import { Toaster } from "./components/ui/toaster";
import PaymentPage from "./pages/PaymentPage";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function AppContent() {
  const { isAuthenticated } = useAuth();

  return (
    <>
      <Routes>
        {/* Public route for signature page */}
        <Route path="/sign/:token" element={<SignaturePage />} />

        <Route path="/pay/:invoiceId" element={<PaymentPage />} />
        
        {/* Public route for email verification */}
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        
        <Route path="/login" element={
          isAuthenticated ? <Navigate to="/" replace /> : <Login />
        } />
        
        <Route path="/*" element={
          <ProtectedRoute>
            <div className="flex h-screen bg-gray-50">
              <Sidebar />
              <main className="flex-1 ml-64 overflow-y-auto">
                <div className="p-8">
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/equipment" element={<Equipment />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/customers" element={<Customers />} />
                    <Route path="/crew" element={<Crew />} />
                    <Route path="/invoicing" element={<Invoicing />} />
                    <Route path="/calendar" element={<Calendar />} />
                    <Route path="/equipment-calendar" element={<EquipmentCalendar />} />
                    <Route path="/crew-calendar" element={<CrewCalendar />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/bookkeeping" element={<Bookkeeping />} />
                  </Routes>
                </div>
              </main>
            </div>
          </ProtectedRoute>
        } />
      </Routes>
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
